import EmptyBottle from "../../../core/assets/oot/gshd/bottle-empty_32x32.png";
import BaseItem, { BaseItemProps } from "../../../core/items/BaseItem";
import Item from "../../../core/items/Item";
import { ItemDto, ItemLightDto } from "../../../core/items/ItemDataTypes";
import StaticItem from "../../../core/items/StaticItem";
import OotItem, { DbItemProps } from "./OotItem";
import { SimpleItemProps } from "./SimpleItemProps";

let id = "OoT_Empty_Bottle"


export const CommonEmptyBottleItem = () => {


    
        return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <Item id={id} image={EmptyBottle} title="Empty Bottle" updateItem={updateOotItem} item={item} isMajor />
        }}</OotItem>

    
}

const EmptyBottleItem = (props: Omit<BaseItemProps, "id" | "title" | "image">) => {

    return <BaseItem {...props} id="bottle" image={EmptyBottle} title="Empty Bottle" />
}

export default EmptyBottleItem;

export const defaultEmptyBottle: ItemDto = {
    defaultIcon: EmptyBottle,
    title: "EmptyBottle",
    component: EmptyBottleItem,
}


export const SimpleEmptyBottleItem= (props: SimpleItemProps) => {


    return <StaticItem
        image={EmptyBottle}
        onClick={props.onClick}
        name={id}
    />



}


export const DbEmptyBottleItem = (props: DbItemProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultEmptyBottleItem;

    return <Item
        item={item}
        updateItem={props.update}
        image={EmptyBottle}
        id={id}
        title={id}
        isObtained={item.isObtained}
    />


}

const DefaultEmptyBottleItem : ItemLightDto = {
    img: EmptyBottle,
    id: id,
    title: id,
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}